import { render, staticRenderFns } from "./UserGroupEdit.vue?vue&type=template&id=80508a5e&scoped=true"
import script from "./UserGroupEdit.vue?vue&type=script&lang=js"
export * from "./UserGroupEdit.vue?vue&type=script&lang=js"
import style0 from "./UserGroupEdit.vue?vue&type=style&index=0&id=80508a5e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80508a5e",
  null
  
)

export default component.exports